import { useRecoilValue } from "recoil";
import { pipelineState } from "../recoils";

export const usePipeline = (pipelineId: string) => {
  const pipeline = useRecoilValue(pipelineState(pipelineId));

  return { pipeline };
};
